<template>
  <v-dialog
    v-model="mostra"
    width="300"
		ref="dialogo"
		inset
  >
    <template v-slot:activator="{ on }">
			<v-badge
				color="yellow darken-4"
				bottom
				v-model="temFiltro"
			>
				<template v-slot:badge>
					<v-icon dark> mdi-check </v-icon>
				</template>
				<slot :on="on" />
			</v-badge>
    </template>
		<v-list>
			<v-subheader> Filtros da Agenda </v-subheader>
			<v-list-item>
				<SeletorDePotencia
					v-model="filtro.potencia"
					:return-object="true"
					clearable
				/>
			</v-list-item>
			<v-list-item>
				<SeletorDeLojas
					v-model="filtro.loja"
					:return-object="true"
					:potencia="filtro.potencia && filtro.potencia.value"
					clearable
				/>
			</v-list-item>
			<v-list-item>
				<v-combobox
					label="Grau"
					v-model="filtro.grau"
					:items="grausDeSessao"
					clearable
				/>
			</v-list-item>
			<v-list-item>
				<v-combobox
					label="Tipo da Sessão"
					v-model="filtro.tipoDaSessao"
					:items="tiposDeSessao"
					clearable
					auto-select-first
				/>
			</v-list-item>
      <v-card-actions>
        <v-btn
					text
					:color="!temFiltro ? 'grey' : undefined"
					@click="limpar"
				> Limpar </v-btn>
        <v-spacer />
        <v-btn
					text
					color="primary"
					@click="() => mostra = false"
				>
					OK
				</v-btn>
      </v-card-actions>
    </v-list>
  </v-dialog>
</template>

<script lang="ts">
export default {
	model: {
		prop: 'filtro',
	},
}
</script>

<script setup lang="ts">
import { computed, PropType, ref, watch } from 'vue'
import SeletorDePotencia from '@/components/SeletorDePotencia.vue'
import SeletorDeLojas from '@/components/SeletorDeLojas.vue'
import { Filtro } from '../modules/AgendaModule'
import { IGrauDeSessao } from '../../common/types/Evento'
import { tiposDeSessaoParcial } from '../shareds/sharedsEvento'

const props = defineProps({
	default: {
		type: Object as PropType<Filtro>,
		default: () => ({
			potencia: null,
			loja: null,
			grau: null,
			tipoDaSessao: null,
		} satisfies Filtro),
	},
	filtro: {
		type: Object as PropType<Filtro>,
		required: true,
	},
})

const emit = defineEmits<{
	(e: 'input', filtro: Filtro): void
}>()

const mostra = ref(false)

const tiposDeSessao = tiposDeSessaoParcial

const grausDeSessao: IGrauDeSessao[] = [
	'Grau 1',
	'Grau 2',
	'Grau 3',
]

const temFiltro = computed(() => JSON.stringify(props.default) !== JSON.stringify(props.filtro))

watch(() => props.filtro, (filtro) => {
	emit('input', filtro)
})

function limpar() {
	emit('input', { ...props.default })
	mostra.value = false
}
</script>
